const NotificationTypes = {
  REVIEW: "reviews",
  DATE_REQUEST: "dateNotificationRequests"
};

export default NotificationTypes;
